import { action, makeObservable, observable } from "mobx";
import NotificationService from "../../services/NotificationService";
import { Notification } from "./types";
import authStore from "../AuthStore";
import configStore from "../ConfigStore";

class NotificationStore {
  @observable notifications: Notification[] = [];
  @observable notificationsCount = 0;
  notificationService: NotificationService = new NotificationService();
  page = 0;

  constructor() {
    makeObservable(this);

    if (configStore.appConfig.notificationInterval) {
      setInterval(() => {
        this.fetchNotifications(this.page);
      }, configStore.appConfig.notificationInterval);
    }
  }

  @action async fetchNotifications(page: number) {
    if (!authStore.isAuthenticated && !!authStore.user) {
      return;
    }

    try {
      const { results, count } =
        await this.notificationService.getNotifications(page, 50);
      this.notifications = results;
      this.notificationsCount = count;
    } catch (error: any) {
      console.error(error);

      // TODO: Remove after implementing an Error Boundary
      if (error.request.status.toString() === "403") {
        authStore.afterLogout();
      }
    }
  }

  async markAsRead(id: string) {
    return this.notificationService.markAsRead(id).then(() => {
      this.notifications = this.notifications.map((n) =>
        n._id === id ? { ...n, isRead: true } : n
      );
    });
  }

  registerDevice(device: Device, registrationId: string) {
    return this.notificationService.registerDevice(device, registrationId);
  }
}

export default NotificationStore;
